
































































































import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      collapsed: false,
      currentId: ''
    }
  },
  computed: {
    ...mapGetters(['appRoutes', 'drawer', 'appName', 'wmsRoutes']),
    currentMaterialId: {
      get() {
        console.log('nicole11111111111:', this.wmsRoutes)
        if (this.$route.query.materialId) {
          this.currentId = ''
          return this.$route.query.materialId
        } else {
          if (this.currentId == '') {
            return this.wmsRoutes && this.wmsRoutes[0] && this.wmsRoutes[0].id
          } else {
            return ''
          }
        }
      },
      set() {
        console.log()
      }
    },
    materialList() {
      return this.$store.state.permission.materialRoutes
    },
    statisticalList() {
      return this.$store.state.permission.statisticalRoutes
    },
    isInDrawer() {
      return function(path) {
        return this.drawer.filter((item) => item.link === path).length > 0
      }
    },
    currentPath: {
      get() {
        return this.$route.path
      },
      set() {
        // console.log()
      }
    }
  },
  watch: {
    '$route.path': {
      handler(val) {
        console.log('111', val)
        this.$nextTick(() => {
          this.currentPath = val
        })
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('user', ['putInDrawer', 'takeFromDrawer']),
    toggleCollapsed() {
      this.collapsed = !this.collapsed
    },
    goRouter(path, id) {
      this.$router.push('/redirect' + path + '?materialId=' + id)
    },
    goRouterX(path, id) {
      console.log(path)
      this.currentId = id
      this.currentMaterialId = ''
      this.$router.push(path)
    }
  },
  mounted() {
    console.log(this.statisticalList, '物料路由', this.currentMaterialId)
  }
}
